import { LABEL_MAX_CHARACTERS } from "../constants";
import type { TruncateLabel } from "./types";

export const truncateLabel: TruncateLabel = (text) =>
  text.length > LABEL_MAX_CHARACTERS
    ? `${text.slice(0, LABEL_MAX_CHARACTERS).trimEnd()}…`
    : text;
